import React from "react";
import Table from "../CommonTable";
import { useMediaQuery } from "react-responsive";
import { CONSTANTS } from "../../shared/constants";

const FinishedCard = ({ record }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  return (
    <div className="process-card">
      <Table rows={[record]} isMobile={isMobile} />
      <BidInfo record={record} />
    </div>
  );
};

const BidInfo = ({ record }) => {
  return (
    <>
      <div className="bid-info">
        <div className="prices">
          <div>Current Price：{record.currentPrice.toLocaleString()} Yen</div>
          <div>Total Price：{record.totalPrice.toLocaleString()} Yen</div>
        </div>
        <div className="prices">
          <div>Bid Price：{record.bidPrice.toLocaleString()} Yen</div>
          <div>Total Price：{record.totalPrice.toLocaleString()} Yen</div>
        </div>
      </div>
      {CONSTANTS.BID_STATUS.WON === record.status ? (
        <div className="successful-bidder">Your bid has been successful.</div>
      ) : (
        <div className="not successful-bidder">
          Sorry ! Your bid has not been successful
        </div>
      )}
    </>
  );
};

export default FinishedCard;
